module.exports = "<tags-input add-from-autocomplete-only=true display-property=display_name key-property=id ng-disabled=$ctrl.readOnly ng-model=$ctrl.regionTags placeholder=\"{{ 'Add a region...' | translate }}\" replace-spaces-with-dashes=false> <auto-complete source=$ctrl.regionSearch($query) min-length=1></auto-complete> </tags-input> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/regionlist/partial.html
// module id = 552
// module chunks = 0